export const HTTP_STATUS_UNAUTHORIZED = 401
